import { AnimatePresence, motion } from "framer-motion";
import {
  AuthenticatedRoute,
  BusinessRoute,
  PersonalRoute,
  PublicRoute,
} from "./components/routing/RouteGuards";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import Dashboards from "./pages/Dashboards";
import Home from "./pages/Home";
import Login from "./pages/Login";
import { MessageProvider } from "./components/context/MessageContext";
import { ModalProvider } from "./components/context/ModalContext";
import Profile from "./pages/Profile";
import Register from "./pages/Register";
import Team from "./pages/Team";
import { TopicsProvider } from "./components/context/TopicsContext";
import { WebSocketProvider } from "./components/context/WebSocketContext";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <PublicRoute>
              <motion.div>
                <ModalProvider>
                  <Home />
                </ModalProvider>
              </motion.div>
            </PublicRoute>
          }
        />
        <Route
          path="/support"
          element={
            <PublicRoute>
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <ModalProvider>
                  <Home />
                </ModalProvider>
              </motion.div>
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <Register />
              </motion.div>
            </PublicRoute>
          }
        />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <Login />
              </motion.div>
            </PublicRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <AuthenticatedRoute>
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <ModalProvider>
                  <Profile />
                </ModalProvider>
              </motion.div>
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/dashboards"
          element={
            <AuthenticatedRoute>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, ease: "easeIn" }}
              >
                <ModalProvider>
                  <Dashboards />
                </ModalProvider>
              </motion.div>
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/team"
          element={
            <BusinessRoute>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, ease: "easeIn" }}
              >
                <ModalProvider>
                  <Team />
                </ModalProvider>
              </motion.div>
            </BusinessRoute>
          }
        />

        <Route
          path="/:token"
          element={
            <AuthenticatedRoute>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, ease: "easeIn" }}
              >
                <WebSocketProvider>
                  <TopicsProvider>
                    <MessageProvider>
                      <ModalProvider>
                        <Dashboard />
                      </ModalProvider>
                    </MessageProvider>
                  </TopicsProvider>
                </WebSocketProvider>
              </motion.div>
            </AuthenticatedRoute>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Router>
      <div>
        {/* Zoom animation wrapper */}
        <div id="zoom-overlay"></div>

        <AnimatedRoutes />
      </div>
    </Router>
  );
}

export default App;
